import React from 'react';
import { Box, styled } from '@mui/material';

const StyledDrawerMenuUserInfoContainer = styled(({ miniDrawer, ...otherProps }) => (
  <Box {...otherProps} />
))(({ miniDrawer, theme }) => ({
  display: 'flex',
  columnGap: theme.spacing(1),
  flexWrap: 'wrap',
  margin: '10px 0 16px',
  padding: miniDrawer ? '0' : `0 ${theme.spacing(2)}`,
  // Colapsado: avatar centrado (también en desktop, donde sería block).
  ...(miniDrawer && { justifyContent: 'center', alignItems: 'center' }),
  [theme.breakpoints.up('lg')]: {
    display: miniDrawer ? 'flex' : 'block',
    justifyContent: miniDrawer ? 'center' : 'flex-start',
    margin: '10px 0 16px'
  },
  [theme.breakpoints.up('xl')]: {
    margin: `12px 0 ${theme.spacing(2.5)}`
  }
}));

export default StyledDrawerMenuUserInfoContainer;
